import SearchPage from "@/pages/search";
import { getSearchBoards } from "@/services";
import { getKeyWordInfo, getSeoInlinks } from "@/services/qingzhou";
import { serverSideNotFound } from "@/utils/server/serverSide";
import Head from "next/head";

export async function getServerSideProps({ req, params, res }) {
  const { keyword } = params;

  try {
    const info = await getKeyWordInfo({
      keyword,
      category_code: "topic-board",
    });

    const searchWord = info?.keyword;

    if (!searchWord) {
      return serverSideNotFound(res);
    }

    const [result, inlinks] = await Promise.all([
      getSearchBoards({
        q: searchWord,
        page: 1,
        per_page: 20,
        all_match: 0,
      }),
      getSeoInlinks({
        title: `${searchWord}相关画板-花瓣网`,
        current_url: req.url,
      }),
    ]);

    return {
      props: {
        searchWord,
        inlinks,
        searchResult: result.boards || [],
        facets: result.facets,
      },
    };
  } catch (error) {
    return serverSideNotFound(res);
  }
}

export default function Index({ searchWord, searchResult, facets }) {
  return (
    <>
      <SearchPage
        query={{ type: "board", q: searchWord }}
        searchResult={searchResult}
        serverSideFacets={facets}
        pageInfo={{
          title: searchWord + "画板",
          desc: `${searchWord}画板资源，发现${searchWord}相关画板资源、设计灵感，一键收藏免费下载。花瓣网，设计师灵感库，素材图库分发。`,
        }}
      />
      <Head>
        <title>{`${searchWord}相关画板-花瓣网`}</title>
        <meta name="keywords" content={`${searchWord}`}></meta>
        <meta
          name="description"
          content={`花瓣网为您提供${searchWord}相关画板资源内容，花瓣网, 设计师寻找灵感的天堂！更多${searchWord}相关图片、素材、设计灵感尽在花瓣网。`}
        ></meta>
      </Head>
    </>
  );
}
